import { Suspense, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import Loader from '@components/Loader/Loader'
import WidgetCatalogList from './WidgetCatalogList'
import { useAppDispatch } from 'universal-scripts'
import { addItem, openItemEditor } from 'src/store/slices/dashboard'

import './WidgetCatalog.css'

export default function WidgetCatalog() {
  const [expanded, setExpanded] = useState(true)
  const dispatch = useAppDispatch()
  const handleAddLabel = () => {
    dispatch(openItemEditor({ type: 'label', itemId: null }))
  }
  const handleAddImage = () => {
    dispatch(openItemEditor({ type: 'image', itemId: null }))
  }
  const handleAddSpacer = () => {
    dispatch(
      addItem({
        type: 'spacer',
        itemId: crypto.randomUUID(),
        width: 3,
        title: ''
      })
    )
  }

  return (
    <aside
      id="widget-catalog"
      className={expanded ? 'opened-catalog' : 'closed-catalog'}
    >
      <header>
        <h2 className="ellipsis">
          <FormattedMessage id="widget-catalog.title" />
        </h2>
        <button className="expand-btn" onClick={() => setExpanded(!expanded)}>
          <span className={`icon icon-${expanded ? 'collapse' : 'expand'}`} />
        </button>
      </header>
      <details name="widget-catalog-scope" open={true}>
        <summary className="ellipsis">
          <span className="icon icon-angle-right" />
          <span>
            <FormattedMessage id="widget-catalog.scope.widgets" />
          </span>
        </summary>
        <ul className="widget-catalog-list">
          <li className="widget-catalog-item widget-catalog-item-text">
            <section title="text">
              <span className="icon icon-text" />
              <span className="ellipsis">
                <FormattedMessage id="widget-catalog.text" />
              </span>
            </section>
            <button onClick={handleAddLabel}>
              <FormattedMessage id="add" />
            </button>
          </li>
          <li className="widget-catalog-item widget-catalog-item-image">
            <section title="image">
              <span className="icon icon-image" />
              <span className="ellipsis">
                <FormattedMessage id="widget-catalog.image" />
              </span>
            </section>
            <button onClick={handleAddImage}>
              <FormattedMessage id="add" />
            </button>
          </li>
          <li className="widget-catalog-item widget-catalog-item-spacer">
            <section title="spacer">
              <span className="icon icon-spacer" />
              <span className="ellipsis">
                <FormattedMessage id="widget-catalog.spacer" />
              </span>
            </section>
            <button onClick={handleAddSpacer}>
              <FormattedMessage id="add" />
            </button>
          </li>
        </ul>
      </details>
      <details name="widget-catalog-scope">
        <summary className="ellipsis">
          <span className="icon icon-angle-right" />
          <span>
            <FormattedMessage id="widget-catalog.scope.own" />
          </span>
        </summary>
        <ErrorBoundary errorComponent={ErrorMessage}>
          <Suspense fallback={<Loader mini />}>
            <WidgetCatalogList scope="own" />
          </Suspense>
        </ErrorBoundary>
      </details>
      <details name="widget-catalog-scope">
        <summary className="ellipsis">
          <span className="icon icon-angle-right" />
          <span>
            <FormattedMessage id="widget-catalog.scope.public" />
          </span>
        </summary>
        <ErrorBoundary errorComponent={ErrorMessage}>
          <Suspense fallback={<Loader mini />}>
            <WidgetCatalogList scope="public" />
          </Suspense>
        </ErrorBoundary>
      </details>
    </aside>
  )
}
